module.exports = __webpack_public_path__ + "media/images/icons/plus-f3e793ac46dd85ad07234e24f2edbf8e.svg";